import type { Dispatch } from 'redux';

import { actions as benefits } from 'src/app/v1/state/modules/formData/benefits';
import { actions as qualifications } from 'src/app/v1/state/modules/formData/qualifications';
import { actions as responsibilities } from 'src/app/v1/state/modules/formData/responsibilities';

const actions: Record<string, any> = {
  BENEFITS: {
    ADD: benefits.add,
    EDIT: benefits.edit,
    FILTER_INVALID_ITEMS: benefits.filterInvalidItems,
    ON_BLUR: benefits.onBlur,
    ON_FOCUS: benefits.onFocus,
    REMOVE: benefits.remove,
  },
  QUALIFICATIONS: {
    ADD: qualifications.add,
    EDIT: qualifications.edit,
    FILTER_INVALID_ITEMS: qualifications.filterInvalidItems,
    ON_BLUR: qualifications.onBlur,
    ON_FOCUS: qualifications.onFocus,
    REMOVE: qualifications.remove,
  },
  RESPONSIBILITIES: {
    ADD: responsibilities.add,
    EDIT: responsibilities.edit,
    FILTER_INVALID_ITEMS: responsibilities.filterInvalidItems,
    ON_BLUR: responsibilities.onBlur,
    ON_FOCUS: responsibilities.onFocus,
    REMOVE: responsibilities.remove,
  },
};

type Input = {
  action?: string;
  target?: string;
  item?: Item | null;
};

type Item = {
  id?: string;
  value?: string;
  isEditing?: boolean;
};

export default (input: Input) => (dispatch: Dispatch) => {
  const { action, target } = input;

  if (!action || !target) {
    return null;
  }

  const dispatchAction = actions?.[target]?.[action];
  const id = input.item?.id ?? null;
  const value = input.item?.value ?? '';

  switch (action) {
    case 'ADD': {
      return dispatch(dispatchAction());
    }

    case 'EDIT': {
      return dispatch(dispatchAction(id, value));
    }

    case 'FILTER_INVALID_ITEMS': {
      return dispatch(dispatchAction());
    }

    case 'ON_BLUR':
    case 'ON_FOCUS':
    case 'REMOVE': {
      return dispatch(dispatchAction(id));
    }

    default:
      return null;
  }
};
